import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Response } from '../../shared/models/response.model';
import { FormationObligatoireReglementaire } from '../models/formation.model';
import { FormationCreateRequest } from '../requests/formation-create-request.model';
import { FormationUpdateRequest } from '../requests/formation-update-request.model';

@Injectable({
  providedIn: 'root',
})
export class FormationObligatoireRèglementaireService {
  #http = inject(HttpClient);
  readonly BASE_URL = '/formations-obligatoires-règlementaires';

  trouveParId = (id: string) => this.#http.get<FormationObligatoireReglementaire>(this.BASE_URL + '/' + id);

  trouverTous = (idCartographie: string) =>
    this.#http.get<Response<FormationObligatoireReglementaire>>(this.BASE_URL, { params: { idCartographie } });

  ajouter = (data: FormationCreateRequest) => this.#http.post<FormationObligatoireReglementaire>(this.BASE_URL, data);

  modifier = (id: string, data: FormationUpdateRequest) => this.#http.put<void>(this.BASE_URL + '/' + id, data);

  supprimer = (id: string) => this.#http.delete(this.BASE_URL + '/' + id);
}
